import debounce from 'lodash.debounce';

/**
 * Auto-flushing unique buffer
 */
export class Buffer {
    constructor ({ delay = 5000, onFlush = () => {} } = {}) {
        this.seen = new Set();
        this.buffer = new Set();
        this.delay = delay;
        this.onFlush = onFlush;
        this.debouncedFlush = debounce(this.flush, this.delay);
    }

    add (key) {
        // Skip values that have already been seen
        if (!this.seen.has(key)) {
            this.seen.add(key);
            this.buffer.add(key);
            this.debouncedFlush();
        }
    }

    flush () {
        if (this.buffer.size > 0) {
            const keys = Array.from(this.buffer);
            this.buffer.clear();
            this.onFlush(keys);
        } else {
            console.warn('Tried to flush an empty buffer');
        }    
    }
}
